var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "education-infos" }, [
    _c(
      "div",
      { staticClass: "education-infos--items" },
      [
        _vm.education.title
          ? _c("Item", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_vm._v("Bezeichnung der Ausbildung:")]
                    },
                    proxy: true
                  },
                  {
                    key: "content",
                    fn: function() {
                      return [_vm._v(_vm._s(_vm.education.title))]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1591153046
              )
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.education.educationCompletion
          ? _c("Item", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_vm._v("Status der Ausbildung:")]
                    },
                    proxy: true
                  },
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _c("Label", {
                          attrs: {
                            characteristic: _vm.education.educationCompletion
                          }
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                638028235
              )
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.education.professions && _vm.education.professions.length > 0
          ? _c("Item", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_vm._v("Fachliche Schwerpunkte:")]
                    },
                    proxy: true
                  },
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _c("LabelList", {
                          attrs: {
                            characteristics: _vm.extractCharacteristic(
                              _vm.education.professions
                            ),
                            "label-type": _vm.labelTypeApplication,
                            "last-level-only": ""
                          }
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1856416126
              )
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.validityEligible
          ? _c("Item", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_vm._v("Gültigkeit:")]
                    },
                    proxy: true
                  },
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _vm.education.validityDate
                          ? [
                              _vm._v(
                                "\n\t\t\t\t\tzeitlich beschränkt bis " +
                                  _vm._s(
                                    _vm._f("dateByObject")(
                                      _vm.education.validityDate
                                    )
                                  ) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          : [_vm._v("zeitlich unbeschränkt")]
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                73053099
              )
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.education.start
          ? _c("Item", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_vm._v("Zeitraum:")]
                    },
                    proxy: true
                  },
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _vm.education.end
                          ? [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("monthYearByObject")(
                                      _vm.education.start
                                    )
                                  ) +
                                  " - " +
                                  _vm._s(
                                    _vm._f("monthYearByObject")(
                                      _vm.education.end
                                    )
                                  ) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          : [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("monthYearByObject")(
                                      _vm.education.start
                                    )
                                  ) +
                                  " - aktuell\n\t\t\t\t"
                              )
                            ]
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1886674514
              )
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.education.postgraduate !== undefined
          ? _c("Item", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_vm._v("Postgraduale Ausbildung:")]
                    },
                    proxy: true
                  },
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _vm._v(
                          _vm._s(_vm.education.postgraduate ? "Ja" : "Nein")
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                399067031
              )
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.education.studyEntitlement !== undefined
          ? _c("Item", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_vm._v("Studienberechtigung:")]
                    },
                    proxy: true
                  },
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _vm._v(
                          _vm._s(_vm.education.studyEntitlement ? "Ja" : "Nein")
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                4118590664
              )
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.education.educationCompletionType
          ? _c("Item", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_vm._v("Abschluss durch:")]
                    },
                    proxy: true
                  },
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _c("Label", {
                          attrs: {
                            characteristic:
                              _vm.education.educationCompletionType
                          }
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                798664230
              )
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.education.gainedTitle
          ? _c("Item", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_vm._v("Erworbener Titel:")]
                    },
                    proxy: true
                  },
                  {
                    key: "content",
                    fn: function() {
                      return [_vm._v(_vm._s(_vm.education.gainedTitle))]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1249141846
              )
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.education.schoolLocation
          ? _c("Item", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_vm._v("Ort/e der Ausbildung:")]
                    },
                    proxy: true
                  },
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _c("LabelList", {
                          attrs: {
                            characteristics: _vm.extractCharacteristic(
                              _vm.education.schoolLocation
                            ),
                            "label-type": _vm.labelTypeApplication,
                            "last-level-only": ""
                          }
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1504449124
              )
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.education.instituteName
          ? _c("Item", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_vm._v("Name der Bildungseinrichtung:")]
                    },
                    proxy: true
                  },
                  {
                    key: "content",
                    fn: function() {
                      return [_vm._v(_vm._s(_vm.education.instituteName))]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1455049833
              )
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.education.details
          ? _c("Item", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_vm._v("Details:")]
                    },
                    proxy: true
                  },
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.education.details) }
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1408152924
              )
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }